import script from "./AutofillReviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AutofillReviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./AutofillReviewPanel.vue?vue&type=style&index=0&id=00e813be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e813be"]])

export default __exports__